import * as React from "react";
import { cn } from "@/lib/utils";
import { PUBLIC_CONTAINER_CLASS } from "@/components/common/brandTokens";

/**
 * Container público institucional: max-w-7xl + gutters da Home.
 *
 * Não impõe padding de seção, background nem min-height.
 * Substitui o div existente — não adiciona wrapper extra.
 */
export const PublicContainer = React.forwardRef(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(PUBLIC_CONTAINER_CLASS, className)}
        {...props}
      >
        {children}
      </div>
    );
  },
);

PublicContainer.displayName = "PublicContainer";
